function sortInsideOutsideSpaces(requiredSpaces) {
  const inside = [];
  const outside = [];
  const leftover = [];
  const spaces = [...requiredSpaces];
  for (const space of spaces) {
    if (space.attributes.requiredInside || space.attributes.preferredInside) {
      inside.push(space);
    } else if (space.attributes.requiredOutside || space.attributes.preferredOutside) {
      outside.push(space);
    } else {
      leftover.push(space);
    }
  }
  return { inside, outside, leftover };
}
export {
  sortInsideOutsideSpaces
};
//# sourceMappingURL=index63.js.map
